import { render, staticRenderFns } from "./kernel.vue?vue&type=template&id=5b0aa180&"
import script from "./kernel.vue?vue&type=script&lang=babel&"
export * from "./kernel.vue?vue&type=script&lang=babel&"
import style0 from "./kernel.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports